<template>
  <div class="header noSelect">
    <div class="header-top">
      <div class="header-top-center">
        <div class="header-top-left">
          你好，欢迎 <span v-if="isShow">来到{{ manystore.manystore_name }}，</span>
          <div v-if="user">
            <span class="nickname" @click="onJumpPages('/user')">{{ user.nickname }}</span>
            <a class="logout" href="javascript:void(0);" @click="onLogout">退出</a>
          </div>
          <div v-else>
            请先<a href="javascript:void(0);" class="header-top-left-text" @click="onJumpPages('/login?type=register')">注册</a>或者
            <a href="javascript:void(0);" class="header-top-left-text" @click="onJumpPages('/login')">登录</a>
          </div>
        </div>
        <div class="header-top-right">
          <!--          <div class="header-top-right-item" @click="onJumpPages('/join')">-->
          <!--            <span class="iconfont icon-jiameng"></span>-->
          <!--            <span class="header-right-nav">分站加盟</span>-->
          <!--          </div>-->
          <div class="header-top-right-item" @click="onJumpPages('/invitation')">
            <span class="iconfont icon-a-ziyuan103"></span>
            <span class="header-right-nav">邀请好友</span>
          </div>
          <div class="header-top-right-item" @click="onJumpPages('/help')">
            <span class="iconfont icon-zhinan"></span>
            <span class="header-right-nav">代发指南</span>
          </div>
          <div class="header-top-right-item" @click="onJumpPages('/news')">
            <span class="iconfont icon-bangzhuzhongxin"></span>
            <span class="header-right-nav">帮助中心</span>
          </div>
        </div>
      </div>
    </div>

    <div class="header-nav-main">
      <div class="header-content">
        <div class="header-logo" @click="$router.push('/')">
          <img class="logo" v-if="isShow" :src="logo" />
          <img class="logo" v-else :src="IMG_URL + '/images/logo360.png'" />
          <div class="collection-btn" @click="onCollect"></div>
        </div>
        <div class="header-nav-list">
          <div :class="{ active: $route.name === 'index' }" class="header-nav-item" @click="onJumpPages('/')">
            <a class="nav-item" href="javascript:void(0);">首页</a>
            <div class="bottom-border"></div>
          </div>
          <div :class="{ active: $route.name === 'product' }" class="header-nav-item" @click="onJumpPages('/product')">
            <a class="nav-item" href="javascript:void(0);">所有商品</a>
            <div class="bottom-border"></div>
          </div>
          <div :class="{ active: $route.name === 'order' }" class="header-nav-item" @click="onJumpPages('/order/add')">
            <a class="nav-item" href="javascript:void(0);">立即发货</a>
            <div class="bottom-border"></div>
          </div>
          <div :class="{ active: $route.name === 'user' }" class="header-nav-item" @click="onJumpPages('/user')">
            <a class="nav-item" href="javascript:void(0);">会员中心</a>
            <div class="bottom-border"></div>
          </div>
          <div :class="{ active: $route.name === 'join' }" class="header-nav-item" @click="onJumpPages('/join')">
            <a class="nav-item" href="javascript:void(0);">分站加盟</a>
            <div class="bottom-border"></div>
          </div>
          <el-dropdown @command="handleCommand">
            <div :class="{ active: $route.name === 'walletLog' }" class="header-nav-item" @click="onJumpPages('/walletLog')">
              <a class="nav-item" href="javascript:void(0);">资金明细</a>
              <div class="bottom-border"></div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="/recharge">充值</el-dropdown-item>
              <!--              <el-dropdown-item command="/withdrawal">提现</el-dropdown-item>-->
            </el-dropdown-menu>
          </el-dropdown>

          <div :class="{ active: $route.name === 'service' }" class="header-nav-item" @click="onJumpPages('/service')">
            <a class="nav-item" href="javascript:void(0);">收费标准</a>
            <div class="bottom-border"></div>
          </div>

          <el-dropdown @command="handleCommand">
            <div :class="{ active: $route.name === 'orderList' }" class="header-nav-item" @click="onJumpPages('/order/lst')">
              <a class="nav-item" href="javascript:void(0);">订单列表</a>
              <div class="bottom-border"></div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="/order/packagelst">包裹列表</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <div :class="{ active: $route.name === 'aftermarket' }" class="header-nav-item" @click="onJumpPages('/aftermarket')">
            <a class="nav-item" href="javascript:void(0);">售后服务</a>
            <div class="bottom-border"></div>
          </div>

          <!-- <div v-if="isShow" :class="{'active': $route.name === 'about'}" class="header-nav-item" @click="onJumpPages('/about?id=63')">
            <a class="nav-item" href="javascript:void(0);">关于我们</a>
            <div class="bottom-border"></div>
          </div> -->
          <div v-if="isZhongZhuan" :class="{ active: $route.name === 'about' }" class="header-nav-item" style="overflow: inherit;">
            <a class="nav-item" href="http://blzz.daifabashi.com/" target="blank"
              >中转仓
              <i class="item">
                hot
              </i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="feedback-box" @click="onJumpPages('/feedback')">
      <img class="feedback-icon" :src="IMG_URL + 'images/feedback-icon.png'" alt="" />
    </div>

    <!--点击音效-->
    <audio ref="clickAudio" style="opacity: 0;z-index: -10;">
      <source :src="`${IMG_URL}click.mp3`" type="audio/mpeg" />
      您的浏览器不支持 audio 元素。
    </audio>
  </div>
</template>

<script>
export default {
  name: "headerNav",
  data() {
    return {};
  },
  computed: {
    manystore() {
      return this.$store.getters.manystore;
    },
    user() {
      return this.$store.getters.user;
    },
    logo() {
      return this.API_URL + this.$store.getters.manystore.logo;
    },
    isShow() {
      var show = true;
      var hosts = ["dfh.jianuojy.com"];
      for (let i = 0; i < hosts.length; i++) {
        var host = location.host;
        if (hosts[i] === host) {
          show = false;
        }
      }
      return show;
    },
    isZhongZhuan() {
      if (document.title.indexOf("伯乐") > -1) {
        return true;
      }
      return false;
    },
  },
  mounted() {},
  methods: {
    onCollect() {
      var url = "/";
      var title = "代发虎";
      try {
        window.external.addFavorite(url, title);
      } catch (e) {
        try {
          window.external.addPanel(title, url, "");
        } catch (e) {
          this.$message.info("加入收藏失败，请使用Ctrl+D进行添加");
        }
      }
    },
    //退出登录
    onLogout() {
      this.$confirm("是否确定退出登录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.dispatch("FedLogOut").then(() => {
          this.$router.push("/login");
        });
      });
    },
    handleCommand(command) {
      this.onJumpPages(command);
    },
    onJumpPages(url) {
      // this.$refs.clickAudio.play();
      setTimeout(() => {
        this.$router.push(url);
      }, 300);
    },
  },
};
</script>

<style scoped lang="scss">
.item {
  background: #f05555;
  border-color: #f05555;
  display: block;
  padding: 0 6px;
  font-size: 12px;
  white-space: nowrap;
  height: 18px;
  color: #fff;
  line-height: 18px;
  border-radius: 4px;
  position: absolute;
  top: -25px;
  left: 80%;
  font-style: normal;
  animation: tag1 2s linear infinite;
  -webkit-animation: tag1 2s linear infinite;

  position: absolute;
  top: -15px;
  left: 40px;
}

@keyframes tag1 {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
  100% {
    transform: translateY(0);
  }
}

.item::after {
  content: "";
  display: block;
  border: 4px solid transparent;
  border-style: solid;
  border-top-color: inherit;
  position: absolute;
  top: 100%;
  left: 4px;
}
.header {
  min-width: 1300px;

  .header-top {
    height: 30px;
    // background-color: #0f375a; //国庆节
    border-bottom: 1px solid #ffffff;

    .header-top-center {
      height: 30px;
      width: 1300px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .header-top-left {
        color: #ffffff;
        font-size: 12px;
        display: flex;
        align-items: center;

        .header-top-left-text {
          color: #ffffff;
          margin: 0 2px;
        }
        .nickname {
          color: #ffffff;
        }
        .logout {
          color: #999999;
          font-size: 12px;
          margin-left: 5px;
        }
      }

      .header-top-right {
        display: flex;
        align-items: center;

        .header-top-right-item {
          margin-left: 20px;
          color: #ffffff;
          font-size: 12px;
          display: flex;
          align-items: center;
          cursor: pointer;

          .iconfont {
            font-size: 14px;
            color: #ffffff;
            margin-top: 2px;
            margin-right: 5px;
          }
        }
      }
    }
  }
  .header-nav-main {
    width: 100%;
    min-width: 1300px;
    height: 100px;
    // background-color: #0f375a; 国庆节
    display: flex;
    align-items: center;
    justify-content: center;

    .header-content {
      width: 1300px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .header-logo {
        position: relative;

        .logo {
          height: 60px;
          width: auto;
        }

        .collection-btn {
          width: 190px;
          height: 50px;
          position: absolute;
          right: 0;
          top: 6px;
          cursor: pointer;
        }
      }

      .header-nav-list {
        display: flex;
        align-items: center;

        .header-nav-item {
          font-size: 14px;
          padding: 10px 15px;
          color: #ffffff;
          cursor: pointer;
          overflow: hidden;
          position: relative;

          .bottom-border {
            transition: all 1s ease;
          }

          &:hover {
            .nav-item {
              font-weight: bold;
              color: #ffffff;
            }

            .bottom-border {
              position: absolute;
              left: 50%;
              bottom: 0;
              transform: translate(-50%, 0);
              height: 2px;
              border-radius: 1px;
              width: 26px;
              background-color: #ffffff;
            }
          }
        }

        .active {
          .nav-item {
            font-weight: bold;
            color: #ffffff;
          }

          .bottom-border {
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translate(-50%, 0);
            height: 2px;
            border-radius: 1px;
            width: 26px;
            background-color: #ffffff;
          }
        }
      }
    }
  }

  .feedback-box {
    height: 50px;
    position: fixed;
    z-index: 1000;
    right: 30px;
    bottom: 120px;
    cursor: pointer;

    .feedback-icon {
      width: auto;
      height: 100%;
    }
  }
}
.el-dropdown-menu {
  min-width: 90px;
  text-align: center;
  padding: 0;
  border: none;
  overflow: hidden;
  border-radius: 0;
  top: 86px !important;
}
.el-dropdown-menu__item {
  color: #0f375a;
  border-radius: 0;
}
.el-dropdown-menu__item:hover {
  background-color: #e4e4e4;
  color: #000000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/headerNav/index.vue